import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=c34be1ac&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=c34be1ac&prod&lang=css"
import style1 from "./settings.vue?vue&type=style&index=1&id=c34be1ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34be1ac",
  null
  
)

export default component.exports